/**
 * Just-in-time purchase order refusals: the browser half of
 * `apps/backend/src/lib/jit-po-errors.ts`.
 *
 * The server throws a TRPCError whose MESSAGE is `JIT_PO_<KEY>:<json>` and
 * whose `cause.code` is `JIT_PO_<KEY>` (FORWARDABLE_CAUSE_CODES). The parsing
 * (cause first, the marker as the fallback) is the one shared
 * `parseMarkerError`; this file keeps only the key list. Operators never see a
 * marker: callers map the key to their own sentence, and `jitPoErrorKey` is
 * null for anything else.
 *
 * Shared by every just-in-time surface (the pick list's Update buy list, the
 * JIT PO page, To buy), so there is one parser for the one marker shape.
 */
import { JIT_PO_ERROR_KEYS, type JitPoErrorKey } from '@threadheads/shared';
import { parseMarkerError, type MarkerErrorInfo } from '@/lib/trpc-error-utils';

export type JitPoErrorInfo = MarkerErrorInfo<JitPoErrorKey>;

/** The just-in-time refusal behind a failed call, or null when it is not one. */
export const parseJitPoError = (error: unknown): JitPoErrorInfo | null =>
  parseMarkerError(error, 'JIT_PO_', JIT_PO_ERROR_KEYS);

/** Just the key, for a caller that only branches on it. */
export const jitPoErrorKey = (error: unknown): JitPoErrorKey | null => parseJitPoError(error)?.key ?? null;
